// src/modules/app-views/leads/pages/Document/tabs/RecordTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Collapse } from 'antd';
import { UnorderedListOutlined, CodeOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import LeadAdditionalInfoContent from './LeadAdditionalInfoCard';
import LeadPayloadContent from './LeadPayloadCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const LeadsRecordTab = props => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [additionalInfoKeys, setAdditionalInfoKeys] = useState([]);
  const [payloadKeys, setPayloadKeys] = useState([]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="p-3">
      {/* Additional Info — starts OPEN */}
      <Collapse
        size="small"
        activeKey={additionalInfoKeys}
        onChange={keys => setAdditionalInfoKeys(keys)}
        style={{ marginBottom: 12 }}
        styles={{
          header: { alignItems: 'center' },
          body: { padding: 20 },
        }}
        items={[
          {
            key: 'additionalInfo',
            forceRender: true,
            label: (
              <span style={{ display: 'inline-flex', alignItems: 'center', height: 40 }}>
                <UnorderedListOutlined style={{ marginRight: 6 }} />
                {translateX('additional_info')}
              </span>
            ),
            children: <LeadAdditionalInfoContent {...props} />,
          },
        ]}
      />

      {/* Payload — starts CLOSED */}
      <Collapse
        size="small"
        activeKey={payloadKeys}
        onChange={keys => setPayloadKeys(keys)}
        style={{ marginBottom: 12 }}
        styles={{
          header: { alignItems: 'center' },
          body: { padding: 20 },
        }}
        items={[
          {
            key: 'payload',
            forceRender: true,
            label: (
              <span style={{ display: 'inline-flex', alignItems: 'center', height: 40 }}>
                <CodeOutlined style={{ marginRight: 6 }} />
                {translateX('payload')}
              </span>
            ),
            children: <LeadPayloadContent {...props} />,
          },
        ]}
      />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default LeadsRecordTab;
